/**
 * Textarea Renderer
 * Features: multi-line text input with maxLength
 */
import React from 'react';
import { Label } from '@/components/ui/label';
import type { FieldRenderer } from '@/MyCode/core';

export const renderTextarea: FieldRenderer = ({
    field,
    value,
    hasError,
    handleChange,
    isRequired
}) => (
    <div className="space-y-2">
        <Label htmlFor={field.name}>
            {field.label}
            {isRequired && <span className="text-destructive ml-1">*</span>}
        </Label>
        <textarea
            id={field.name}
            placeholder={field.placeholder}
            value={value || ''}
            onChange={(e) => handleChange(field.name, e.target.value)}
            maxLength={field.maxLength}
            className={`flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 ${
                hasError ? 'border-destructive' : ''
            }`}
        />
    </div>
);

export default renderTextarea;